import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Row, Col } from "antd";
import { OrderPlacedContext } from "../../index";

const Redirect = () => {
  const value = useContext(OrderPlacedContext);
  const { poId } = value;

  return (
    <Row type="flex" justify="center" align="middle">
      <Col span={15}>
        <Row type="flex" align="middle" className="osp-footer">
          <Col span={12}> </Col>
          <Col span={24}>
            <NavLink to={`/order-tracking/${poId}`}>Track Order</NavLink>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default Redirect;
